import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useState } from "react";

type BannerProps = {
    severity?: "error" | "warning" | "info" | "success";
    message: string;
};

export const HeaderNotification = ({ severity = "warning", message }: BannerProps) => {
    const [open, setOpen] = useState(true);
    if (!open) return null;

    const icons = {
        error: <ErrorOutlineIcon className="text-red-600" />,
        warning: <WarningAmberIcon className="text-yellow-600" />,
        info: <InfoOutlinedIcon className="text-blue-600" />,
        success: <CheckCircleOutlineIcon className="text-green-600" />,
    };

    const styles = {
        error: "bg-red-50 border-red-200 text-red-800",
        warning: "bg-yellow-50 border-yellow-200 text-yellow-800",
        info: "bg-blue-50 border-blue-200 text-blue-800",
        success: "bg-green-50 border-green-200 text-green-800",
    };

    return (
        <div
            className={`flex items-center justify-between px-4 py-2 border ${styles[severity]} rounded-md shadow-sm`}
        >
            <div className="flex items-center gap-2">
                {icons[severity]}
                <span className="text-sm font-medium">{message}</span>
            </div>
            <IconButton size="small" onClick={() => setOpen(false)}>
                <CloseIcon fontSize="small" />
            </IconButton>
        </div>
    );
};
